import { render, staticRenderFns } from "./assessment-overview-cards.component.vue?vue&type=template&id=c1c9f158&scoped=true&"
import script from "./assessment-overview-cards.component.vue?vue&type=script&lang=ts&"
export * from "./assessment-overview-cards.component.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-overview-cards.component.vue?vue&type=style&index=0&id=c1c9f158&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c9f158",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
